import { PLAYLIST_ITEMS_RESOURCE, PLAYLISTS_RESOURCE_V2 } from "../api/resources";
import {
  addResource,
  deleteResource,
  fetchResource,
  updateResource,
  putResource,
} from "./remote";
import { API_ROOT } from "signoxe/constants/config";
import { actions as notifActions } from "redux-notifications";
import { fetchAll } from "signoxe/actions/fetchAll";
import {
  SEARCH_PLAYLISTS,
  FILTER_PLAYLISTS,
  FETCH_EVENTS_LOCATIONS,
  FETCH_PLAYLIST_REQUEST,
  FETCH_PLAYLIST_SUCCESS,
  FETCH_PLAYLIST_FAILURE
} from "signoxe/constants/actionTypes";

const { notifSend } = notifActions;
const getAuthTokenHeader = () => `Bearer ${localStorage.getItem("token")}`;

export const fetchPlaylistsV2 = fetchResource(PLAYLISTS_RESOURCE_V2);
export const fetchPagedPlayistsV2 = (url) =>
  fetchResource(PLAYLISTS_RESOURCE_V2, false, url)();

export const updatePlaylistV2 = updateResource(PLAYLISTS_RESOURCE_V2);

export const addPlaylistV2 = addResource(PLAYLISTS_RESOURCE_V2);

export const deletePlaylistV2 = deleteResource(PLAYLISTS_RESOURCE_V2);

export const clonePlaylistV2 = addResource(PLAYLISTS_RESOURCE_V2, "clone");


export const filterPlaylistByTag = (tag) => ({
  type: FILTER_PLAYLISTS,
  filterBy: "TAGS",
  filter: tag,
});

export const setPlaylistTags = putResource({
  resource: PLAYLISTS_RESOURCE_V2,
  subResource: "tags",
  route: "detail",
});




export const fetchPlaylistRequest = () => ({
  type: FETCH_PLAYLIST_REQUEST,
});

export const fetchPlaylistSuccess = (playlistData) => ({
  type: FETCH_PLAYLIST_SUCCESS,
  payload: playlistData,
});

export const fetchPlaylistFailure = (error) => ({
  type: FETCH_PLAYLIST_FAILURE,
  payload: error,
});


export const fetchPlaylistDetail = (id) => async (dispatch) => {
  console.log("detail playlist got here", id);
  localStorage.setItem("playlist_id", id)

  dispatch(fetchPlaylistRequest());

  const url = `${API_ROOT}playlists/${id}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(url, options);

    if (response.ok) {
      const playlistData = await response.json();

      // Dispatch the success action with the fetched data
      dispatch(fetchPlaylistSuccess(playlistData));
      console.log("Playlist data:", playlistData);
    } else {
      console.log("API Error:", response);

      // Dispatch the failure action with the error message
      dispatch(fetchPlaylistFailure('Failed to fetch playlist'));
    }

    if (response.status === 500) {
      alert("Something went wrong");
    }
  } catch (err) {
    console.error("Error:", err);

    // Dispatch the failure action with the caught error
    dispatch(fetchPlaylistFailure('Failed to fetch playlist'));
    alert(err);
  }
};

export const updatePlaylist = (id, updatedData) => async (dispatch) => {
  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(updatedData),
  };

  try {
    const response = await fetch(`${API_ROOT}playlists/${id}/`, requestOptions);
    
    if (response.ok) {
      const updatedPlaylist = await response.json();
      dispatch(fetchPlaylistSuccess(updatedPlaylist));
    } else {
      console.log("API Error:", response);

      // Throw an error, and let the catch block handle it
      throw new Error('Failed to update playlist');
    }
  } catch (error) {
    console.error("Error:", error);

    // Dispatch the failure action with the caught error
    dispatch(fetchPlaylistFailure('Failed to update playlist'));
    alert(error.message);
  }
};




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/playlistV2.js